module.exports = __webpack_public_path__ + "static/img/bg_go_link.6ec3de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg_go_link.png
// module id = po+M
// module chunks = 10